import { NaniumObject, RequestType, Type } from 'nanium/objects';
import { ServiceRequestBase } from '../serviceRequestBase';
import { AddressType } from "../../entities/types/address.type";
import { GeoLocationType } from "../../entities/types/geoLocation.type";

export class GeolocationGetCoordinatesFromAddressRequestBody extends NaniumObject<GeolocationGetCoordinatesFromAddressRequestBody> {
	@Type(AddressType) address?: AddressType;
	@Type(String) regionName?: string;
}

@RequestType({
	responseType: GeoLocationType,
	genericTypes: { TRequestBody: GeolocationGetCoordinatesFromAddressRequestBody },
	scope: 'public',
	skipInterceptors: true
})
export class GeolocationGetCoordinatesFromAddressRequest extends ServiceRequestBase<GeolocationGetCoordinatesFromAddressRequestBody, GeoLocationType> {
	static serviceName: string = 'NaniumDemo:geolocation/getCoordinatesFromAddress';
}
